import AddIcon from '@mui/icons-material/Add';
import { ModalFormButton, FormFieldsData } from 'framework/form';
import { AddExpertiseItem } from 'domain/people/employee/expertise/service/expertiseService.types';
import { useShowContext } from 'framework/show';
import { useAuthorization } from 'framework/authorization';
import { ExpertisePermission } from 'domain/people/employee/expertise/service/expertiseService.model';
import useExpertiseService from 'domain/people/employee/expertise/service/expertiseService';
import { useCallback } from 'react';
import expertiseValidationSchema from './expertiseValidationSchema';
import { Tooltip } from 'framework/ui/mui-builder';
import AddExpertiseForm from './AddExpertiseForm';

const MODAL_ACTION_LABEL = 'Add expertise';

interface Props {
  initialData?: FormFieldsData | undefined;
}

const AddExpertiseAction = ({ initialData }: Props) => {
  const { addEmployeeExpertise } = useExpertiseService();
  const { data: employeeData } = useShowContext();
  const positionId = employeeData?.positionId;
  const { isGranted } = useAuthorization();

  const submitFormFunc = useCallback(
    ({ expertiseId, experienceDuration, expertiseType, level, comment }: FormFieldsData) => {
      const item: AddExpertiseItem = {
        expertiseId,
        experienceDuration,
        expertiseType,
        level,
        comment,
      };
      return addEmployeeExpertise({
        positionId,
        items: [item],
      });
    },
    [addEmployeeExpertise, positionId],
  );

  if (!isGranted(ExpertisePermission.PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_ASSIGN)) {
    return null;
  }

  return (
    <ModalFormButton
      formTitle={MODAL_ACTION_LABEL}
      getValidationSchemaFunc={async () => expertiseValidationSchema}
      label={
        <Tooltip title="Add expertise">
          <AddIcon fontSize="small" />
        </Tooltip>
      }
      submitFormFunc={submitFormFunc}
      submitButtonText={MODAL_ACTION_LABEL}
      paperStyles={{
        background: 'var(--mui-palette-background-paper)',
      }}
      sxButton={{
        minWidth: 'auto',
        p: 0,
      }}
      initialData={initialData}
    >
      <AddExpertiseForm />
    </ModalFormButton>
  );
};

export default AddExpertiseAction;
